import { makeStyles } from '@material-ui/core/styles';
import ImageIcon from '@material-ui/icons/Image';
import { Column } from 'devextreme-react/data-grid';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { formatPrice, getGCSUri, getMontageImageUrl } from '../../utils';

import SvgIcon from '@material-ui/icons/GetApp';
import { useDispatch } from 'react-redux';
import { queryMontagesById, saveMontagePdf } from '../../actions/montages';
import CustomCell from '../../components/devExpressTable/CustomCell';
import Table from '../../components/devExpressTable/Table';
import { CLOUD_IMAGE_URL, GCS_USERS_BUCKET_NAME } from '../../constant';

const useStyles = makeStyles({
  root: {},
  cell: {
    composes: 'flexRow stretch center',
    height: 50,
  },
  right: {
    composes: 'justifyEnd',
  },
  imageContainer: {
    width: 60,
    height: 60,
  },
  image: {
    width: '100%',
  },
});

const generateSvg = (product) => {
  return `${CLOUD_IMAGE_URL}?id=${product.objectId}&v=${product.version}&format=svg&b=1`;
};

const SVGComponent = () => (
  <svg viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg" className="MuiSvgIcon-root-63">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon" fill="#000000" transform="translate(85.333333, 42.666667)">
        <path
          d="M236.504748,7.10542736e-15 L1.83808102,7.10542736e-15 L1.83808102,234.666667 L44.5047477,234.666667 L44.5047477,192 L44.5047477,169.6 L44.5047477,42.6666667 L218.798081,42.6666667 L300.504748,124.373333 L300.504748,169.6 L300.504748,192 L300.504748,234.666667 L343.171414,234.666667 L343.171414,106.666667 L236.504748,7.10542736e-15 L236.504748,7.10542736e-15 Z M4.26325641e-14,399.067492 L4.16875,374.417492 C18.85,380.579992 31.2958333,383.661242 41.50625,383.661242 C48.1520833,383.661242 53.0458333,382.029992 56.1875,378.767492 C58.90625,375.927909 60.265625,372.45395 60.265625,368.345617 C60.265625,364.6602 58.9364583,361.790409 56.278125,359.736242 C53.6197917,357.682075 47.0645833,354.5102 36.6125,350.220617 C28.8791667,347.018534 23.4265625,344.632075 20.2546875,343.061242 C17.0828125,341.490409 14.1677083,339.708117 11.509375,337.714367 C3.95729167,332.095617 0.18125,323.999784 0.18125,313.426867 C0.18125,304.30395 2.65833333,296.298742 7.6125,289.411242 C15.225,278.717492 27.73125,273.370617 45.13125,273.370617 C57.6979167,273.370617 71.3520833,275.696659 86.09375,280.348742 L80.29375,303.911242 C71.59375,300.709159 65.0536458,298.594575 60.6734375,297.567492 C56.2932292,296.540409 51.7166667,296.026867 46.94375,296.026867 C41.50625,296.026867 37.3677083,297.2352 34.528125,299.651867 C31.5677083,302.249784 30.0875,305.542492 30.0875,309.529992 C30.0875,312.973742 31.3411458,315.677388 33.8484375,317.64093 C36.3557292,319.604471 42.3822917,322.549784 51.928125,326.476867 C61.4135417,330.40395 67.696875,333.137805 70.778125,334.67843 C73.859375,336.219055 76.759375,338.01645 79.478125,340.070617 C86.909375,345.749784 90.625,354.419575 90.625,366.079992 C90.625,379.854992 85.9427083,390.276867 76.578125,397.345617 C68.603125,403.326867 57.4260417,406.317492 43.046875,406.317492 C28.0635417,406.317492 13.7145833,403.900825 4.26325641e-14,399.067492 Z M146.721875,404.051867 L98.05625,275.636242 L128.14375,275.636242 L149.53125,333.273742 C154.96875,347.954992 159.046875,360.038325 161.765625,369.523742 C165.934375,356.232075 169.891667,344.54145 173.6375,334.451867 L195.659375,275.636242 L224.296875,275.636242 L175.63125,404.051867 L146.721875,404.051867 Z M344.465625,332.186242 L344.465625,397.708117 C337.094792,400.1852 331.898958,401.81645 328.878125,402.601867 C319.513542,405.07895 309.454167,406.317492 298.7,406.317492 C277.554167,406.317492 261.453125,401.000825 250.396875,390.367492 C238.132292,378.646659 232,362.30395 232,341.339367 C232,317.233117 239.6125,299.0477 254.8375,286.783117 C265.89375,277.84145 280.816667,273.370617 299.60625,273.370617 C315.677083,273.370617 330.630208,276.300825 344.465625,282.161242 L334.5875,304.726867 C328.0625,301.464367 322.353125,299.183638 317.459375,297.88468 C312.565625,296.585721 307.188542,295.936242 301.328125,295.936242 C287.311458,295.936242 276.980208,300.4977 270.334375,309.620617 C264.715625,317.35395 261.90625,327.534159 261.90625,340.161242 C261.90625,355.325825 266.135417,366.744575 274.59375,374.417492 C281.360417,380.579992 289.758333,383.661242 299.7875,383.661242 C305.647917,383.661242 311.20625,382.664367 316.4625,380.670617 L316.4625,354.842492 L294.35,354.842492 L294.35,332.186242 L344.465625,332.186242 Z"
          id="Combined-Shape"
        ></path>
      </g>
    </g>
  </svg>
);

// const pdfProps = (montage, printMontage) => {
//   if (!montage.pdf)
//     return {
//       onClick: (evt) => {
//         printMontage(montage.objectId);
//         evt.preventDefault();
//       },
//     };
//   return {
//     href: getGCSUri(GCS_USERS_BUCKET_NAME, montage.pdf.id),
//     target: '_blank',
//     rel: 'noreferrer',
//   };
// };

const columns = [
  {
    title: 'Image',
    dataIndex: 'image_url',
    key: 'image_url',
    render: (value) => {
      return <img src={value} alt="product" style={{ width: 50, height: 50, objectFit: 'contain' }} />;
    },
  },
  {
    title: 'Items',
    dataIndex: 'items',
    key: 'items',
    render: (value) => {
      return (
        <div>
          <div style={{ fontWeight: 'bold' }}>{value?.product?.name}</div>
          <span>{value?.variant?.name}</span>
        </div>
      );
    },
  },
  {
    title: 'Quantité',
    dataIndex: 'quantity',
    key: 'quantity',
  },
  {
    title: 'Prix',
    dataIndex: 'price',
    key: 'price',
    render: (value) => formatPrice(value),
  },
  {
    title: 'Total',
    dataIndex: 'total',
    key: 'total',
    render: (value) => formatPrice(value),
  },
  {
    title: 'Assets',
    dataIndex: 'montage',
    key: 'montage',
    render: (montage, printMontage) => {
      const imageUrl = getMontageImageUrl({ id: montage.objectId, ...montage }, false);
      return (
        <>
          <a href={imageUrl} target="_blank" rel="noreferrer">
            <ImageIcon />
          </a>
          {/* <a {...pdfProps(montage, printMontage)}>
            <PictureAsPdfIcon />
          </a> */}
          <a href={generateSvg(montage)} target="_blank" rel="noreferrer">
            <SvgIcon component={SVGComponent} />
          </a>
        </>
      );
    },
  },
];

const ModalProductTable = ({ data }) => {
  const [dataSource, setDataSource] = useState([]);
  const dispatch = useDispatch();

  // styles
  const classes = useStyles();

  const _printMontage = async (montageId) => {
    const pdf = await dispatch(saveMontagePdf(montageId));
    window.open(getGCSUri(GCS_USERS_BUCKET_NAME, pdf.id), '_blank');
  };

  const formatDataSource = async (order) => {
    if (!order) return [];
    const items = order.items || [];
    const montages = order?.metadata?.montages;
    if (montages) {
      const dataMontages = await queryMontagesById(montages).then((res) =>
        res.map((montage) => ({
          ...montage.toJSON(),
          item: items.find((item) => item.variant_id === montage.get('idVariant')),
        }))
      );
      return dataMontages.map((montage, i) => ({
        key: montage.objectId,
        image_url: getMontageImageUrl({ id: montage.objectId, ...montage }, false, true),
        items: montage.item,
        quantity: montage.quantity ?? 0,
        price: montage.item?.price ?? 0,
        total: montage.quantity * (montage.item?.price ?? 0),
        montage,
      }));
    }
    return items.map((item, i) => ({
      key: i,
      items: item,
      quantity: item?.quantity,
      price: item?.price,
      total: item?.price_total,
      image_url: '',
      montage: null,
    }));
  };

  useEffect(() => {
    (async () => {
      const dataSource = await formatDataSource(data);
      setDataSource(dataSource);
    })();
  }, [data]);

  return (
    <div className={classes.root}>
      <Table dataSource={dataSource} showColumnLines={false} invisibleInputSearch={true}>
        {columns.map((column, i) => (
          <Column
            key={i}
            dataField={column.dataIndex}
            caption={column.title}
            alignment="center"
            cellRender={({ data }) => (
              <>
                <CustomCell
                  alignment="center"
                  value={column.render ? column.render(data[column.dataIndex], _printMontage) : data[column.dataIndex]}
                />
              </>
            )}
          />
        ))}
      </Table>
    </div>
  );
};

ModalProductTable.propTypes = {
  data: PropTypes.any,
};

export default ModalProductTable;
